import React, { useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import NegotiationButtonVariant from '../../../../../../_shared/constants/negotiationButtonVariant';
import TradeDetails from '../../../../../../_shared/models/TradeDetails';
import StartNegotiationContainer from '../../../../../ModalButton/NegotiationButton/StartNegotiationContainer';
import RespondNegotiationContainer from '../../../../../ModalButton/NegotiationButton/RespondNegotiationContainer';
import ViewNegotiationContainer from '../../../../../ModalButton/NegotiationButton/ViewNegotiationContainer';
import BidBoxContext from '../../../../BidBoxContainer/BidBoxContext';
import { StyledPrimaryButton, StyledSecondaryButton } from './Styles';
import PendingBidBoxFooterContext from '../../PendingBidBoxFooterContainer/PendingBidBoxFooterContext';
import BidBoxSendToClosingButton from './BidBoxSendToClosingButton';

const PendingBiddingButtons = ({ isOmp = false, tradeContext }) => {
  const { tradeDetails } = useContext(BidBoxContext);
  const isSelling = tradeContext === tradeContext.Sell;
  const { negotiationButtonVariant, negotiationState } = useContext(
    PendingBidBoxFooterContext
  );
  const trade = TradeDetails.asPendingTrade(tradeDetails, negotiationState);

  switch (negotiationButtonVariant) {
    case NegotiationButtonVariant.close:
      return <BidBoxSendToClosingButton isOmp={isOmp} />;
    case NegotiationButtonVariant.start:
      return (
        <StartNegotiationContainer
          trade={trade}
          Button={({ onClick }) => (
            <StyledPrimaryButton onClick={onClick}>
              <FormattedMessage
                id={
                  isSelling
                    ? 'vdp.pending.seller.button.startNegotiation'
                    : 'vdp.pending.buyer.button.startNegotiation'
                }
              />
            </StyledPrimaryButton>
          )}
          isOmp={isOmp}
        />
      );
    case NegotiationButtonVariant.respond:
      return (
        <RespondNegotiationContainer
          trade={trade}
          Button={({ onClick }) => (
            <StyledSecondaryButton onClick={onClick} isSelling={isSelling}>
              <FormattedMessage
                id={
                  isSelling
                    ? 'vdp.pending.seller.button.reply'
                    : 'vdp.pending.buyer.button.reply'
                }
              />
            </StyledSecondaryButton>
          )}
          tradeContext={tradeContext}
          isOmp={isOmp}
        />
      );
    case NegotiationButtonVariant.view:
      return (
        <ViewNegotiationContainer
          trade={trade}
          Button={({ onClick }) => (
            <StyledPrimaryButton onClick={onClick} isSelling={isSelling}>
              <FormattedMessage
                id={
                  isSelling
                    ? 'vdp.pending.seller.button.viewNegotiation'
                    : 'vdp.pending.buyer.button.view'
                }
              />
            </StyledPrimaryButton>
          )}
          isOmp={isOmp}
        />
      );
    default:
      return null;
  }
};

export default PendingBiddingButtons;
